export default "__VITE_ASSET__MqTmAwC7__"